
export const COMBAT_LOG_MESSAGES = {
  player: {
    hit: [
      "You strike {target} for {damage} damage.",
      "Your attack connects, dealing {damage} damage to {target}.",
      "A solid blow! {target} takes {damage} damage.",
      "You land a clean hit on {target} for {damage} damage.",
      "Your weapon finds its mark, inflicting {damage} damage on {target}.",
      "With a powerful swing, you wound {target} for {damage} damage.",
      "You break through {target}'s defense, dealing {damage} damage.",
      "A precise strike from you hits {target} for {damage} damage.",
      "{target} staggers back after taking {damage} damage from your attack.",
      "You deal a punishing {damage} damage to {target}.",
    ],
    miss: [
      "Your attack misses {target}.",
      "{target} deftly avoids your strike.",
      "You swing wide, missing {target} completely.",
      "Your attack glances off {target}'s hide harmlessly.",
      "{target} is too quick, evading your attack.",
      "A miss! You fail to connect with {target}.",
      "You stumble, causing your attack on {target} to go astray.",
      "{target} reads your move and dodges with ease.",
      "Your weapon whistles through the air, missing {target}.",
      "You can't seem to land a blow on {target}.",
    ],
    crit: [
      "A CRITICAL HIT! You smash into {target} for {damage} damage!",
      "A perfect strike! You deal a massive {damage} damage to {target}!",
      "You find a weak spot, landing a critical blow on {target} for {damage} damage!",
      "An incredible hit! {target} reels from {damage} critical damage!",
      "You unleash a devastating attack, critting {target} for {damage} damage!",
      "Bullseye! A critical hit deals {damage} damage to {target}!",
    ],
  },
  adventurer: {
    hit: [
      "[{caster}] hits {target} for {damage} damage.",
      "[{caster}]'s attack finds its mark, dealing {damage} to {target}.",
      "[{caster}] lands a telling blow on {target} for {damage} damage.",
      "A skillful attack from [{caster}] wounds {target} for {damage} damage.",
      "[{caster}] presses the attack, hitting {target} for {damage} damage.",
      "{target} is struck by [{caster}] for {damage} damage.",
      "[{caster}]'s weapon bites deep into {target}, dealing {damage} damage.",
      "With practiced ease, [{caster}] deals {damage} damage to {target}.",
      "[{caster}] finds an opening and strikes {target} for {damage} damage.",
      "{target} roars in pain from [{caster}]'s {damage} damage hit.",
    ],
    miss: [
      "[{caster}]'s attack goes wide of {target}.",
      "{target} sidesteps [{caster}]'s assault.",
      "[{caster}] misses their attack on {target}.",
      "The attack from [{caster}] is easily avoided by {target}.",
      "[{caster}] fails to connect with {target}.",
      "{target} proves too agile for [{caster}]'s attack.",
      "A swing and a miss by [{caster}]!",
      "[{caster}]'s attack is just a hair off-target.",
      "{target} anticipates [{caster}]'s move and evades.",
      "Not even close. [{caster}] misses {target}.",
    ],
    crit: [
      "A brutal CRITICAL HIT from [{caster}]! {target} takes {damage} damage!",
      "[{caster}] exploits an opening, dealing {damage} critical damage to {target}!",
      "An overwhelming strike from [{caster}] crits {target} for {damage} damage!",
      "[{caster}] lands a picture-perfect critical hit on {target} for {damage} damage!",
      "That's gotta hurt! [{caster}] crits {target} for {damage} damage!",
      "In a flash of brilliance, [{caster}] delivers {damage} critical damage to {target}!",
    ],
  },
  monster: {
    hit: [
      "{caster} hits {target} for {damage} damage.",
      "{caster}'s assault wounds {target} for {damage} damage.",
      "{caster} lands a savage blow on {target} for {damage} damage.",
      "{target} takes {damage} damage from {caster}'s furious attack.",
      "A vicious strike from {caster} connects with {target} for {damage} damage.",
      "{caster}'s raw power overwhelms {target}, dealing {damage} damage.",
      "{target} stumbles from a heavy {damage} damage blow by {caster}.",
      "{caster} claws at {target}, inflicting {damage} damage.",
      "The attack from {caster} smashes into {target} for {damage} damage.",
      "{target} is brutalized by {caster} for {damage} damage.",
    ],
    miss: [
      "{caster}'s attack misses {target}.",
      "{target} deftly avoids {caster}'s strike.",
      "{caster} swings wildly and misses {target}.",
      "{target} is unharmed as {caster}'s attack fails to connect.",
      "The clumsy attack from {caster} misses {target} by a mile.",
      "{target}'s defenses hold, and {caster}'s attack misses.",
      "{caster} lunges but {target} steps aside.",
      "A futile attempt; {caster} cannot hit {target}.",
      "{caster} screeches in frustration as its attack on {target} misses.",
      "{target} is too nimble for the lumbering {caster}.",
    ],
    dodge: [
      "[{target}] DODGES the attack from {caster}!",
      "[{target}] narrowly avoids {caster}'s blow!",
      "With a burst of speed, [{target}] evades {caster}'s attack!",
      "Too quick! [{target}] sidesteps the attack from {caster}!",
      "[{target}] ducks under {caster}'s clumsy swing!",
      "{caster} is left hitting air as [{target}] dodges.",
    ],
  },
  general: {
    slain: [
      "{target} has been slain.",
      "{target} falls to the ground, defeated.",
      "{target} collapses, its fighting days over.",
      "The light fades from {target}'s eyes.",
      "{target} has been vanquished!",
      "Another one bites the dust. {target} is defeated.",
      "The final blow lands, and {target} is no more.",
    ],
    parry: [
      "[{parrier}] parries the attack from {attacker}!",
      "Sparks fly as [{parrier}] deflects {attacker}'s blow with their weapon!",
      "A skillful parry! [{parrier}] turns aside {attacker}'s attack.",
      "With a sharp ring of steel, [{parrier}] parries {attacker}'s strike.",
      "Not so fast! [{parrier}] masterfully parries {attacker}'s assault.",
      "[{parrier}] meets {attacker}'s blade with their own, nullifying the attack.",
    ],
    block: [
      "[{blocker}] blocks the attack from {attacker} with their shield!",
      "The attack from {attacker} thuds harmlessly against [{blocker}]'s shield.",
      "[{blocker}] raises their shield just in time to block {attacker}'s blow.",
      "A solid block! [{blocker}] stands firm against {attacker}'s attack.",
      "The shield holds! [{blocker}] negates the damage from {attacker}.",
      "{attacker}'s weapon is turned away by [{blocker}]'s sturdy shield.",
    ],
  },
};
